<div class="inventory-form-container">

  <!-- HEADER -->
  <div class="form-header">
    <div class="title">
      <ng-container [ngSwitch]="dialogData.mode">
        <!-- Simple Title Modes -->
        <h2 *ngSwitchCase="'add'" class="form-title">Add New Order Item</h2>
        <h2 *ngSwitchCase="'issue-new-item'" class="form-title">{{ dialogData.isEdit ? 'Edit Item' : 'Issue New Item' }}</h2>
        <h2 *ngSwitchCase="'bulk-issue-upload'" class="form-title">{{ dialogData.isOrder ? 'Bulk Procured Upload' : 'Bulk Issue Upload' }}</h2>
        <h2 *ngSwitchCase="'add-invoice'" class="form-title">Add Invoice - {{ dialogData.rowData?.itemName }}</h2>
        <h2 *ngSwitchCase="'view-invoice'" class="form-title">Invoice - {{ dialogData.rowData?.itemName }}</h2>

        <!-- View Mode with Additional Info -->
        <div *ngSwitchCase="'view'" class="title-with-info">
          <div class="main-title">
            {{ dialogData.rowData?.productName + ' - ' + dialogData.rowData?.subProductName + (dialogData.rowData?.size
            && dialogData.rowData?.size !== 'N/A' ? ' - ' + dialogData.rowData?.size : '') }}
          </div>

        </div>
      </ng-container>

      <button class="close-button" type="button" (click)="closeForm()">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
      </button>
    </div>
  </div>

  <!-- CONTENT -->
  <div class="form-content">

    <!-- ============================ -->
    <!--       VIEW INVOICE MODE      -->
    <!-- ============================ -->
    <div *ngIf="isInvoiceViewMode" class="invoice-container">
      <img *ngIf="safeInvoiceUrl" [src]="safeInvoiceUrl" class="invoice-preview-image" alt="Invoice Preview" />

      <div *ngIf="!safeInvoiceUrl" class="error-msg">
        Unable to load invoice.
      </div>
    </div>

    <!-- ============================ -->
    <!--       ADD INVOICE MODE       -->
    <!-- ============================ -->

    <form *ngIf="isInvoiceAddMode" [formGroup]="invoiceForm" class="form-section">
      <div class="add-invoice-form">
        <app-file-upload label="Upload Invoice Attachment" [error]="fileError" fileTypeText="Pdf format only, upto 3 MB"
          [accept]="'application/pdf'" [selectedFile]="uploadedInvoice" (fileSelected)="onInvoiceSelected($event)"
          (fileRemoved)="onInvoiceRemoved()">
        </app-file-upload>
      </div>
    </form>


    <!-- VIEW INVENTORY -->
    <div class="view-details-container" *ngIf="isViewMode">
      <!-- Info Cards Row -->
      <div class="info-cards-row">
        <div class="info-card">
          <div class="info-label">Available Quantity</div>
          <div class="info-value">{{ dialogData.rowData?.availableQuantity }}</div>
        </div>
        <div class="info-card">
          <div class="info-label">Location</div>
          <div class="info-value">{{ tableHistory[0]?.location }}</div>
        </div>
      </div>

      <!-- History Table -->
      <div class="table-card" *ngIf="tableHistory.length">
        <table class="history-table">
          <thead>
            <tr>
              <th>Procured / Issued</th>
              <th>Date</th>
              <th>Quantity</th>
              <th>Issued/Procured By</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of tableHistory">
              <td>
                <span class="status-badge" [ngClass]="row.type === 'Procured' ? 'badge-procured' : 'badge-issued'">
                  {{ row.type }}
                </span>
              </td>
              <td class="date-cell">{{ row.date ? (row.date | date: 'MMM dd, yyyy') : '-' }}</td>
              <td class="quantity-cell">{{ row.quantity ?? '-' }}</td>
              <td class="user-cell">{{ row.createdBy ?? '-' }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Empty State -->
      <div class="empty-state-card" *ngIf="!tableHistory.length">
        <div class="empty-icon">
          <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M9 12H15M9 16H15M17 21H7C5.89543 21 5 20.1046 5 19V5C5 3.89543 5.89543 3 7 3H12.5858C12.851 3 13.1054 3.10536 13.2929 3.29289L18.7071 8.70711C18.8946 8.89464 19 9.149 19 9.41421V19C19 20.1046 18.1046 21 17 21Z"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </div>
        <div class="empty-title">No Transaction History</div>
        <div class="empty-text">There are no procurement or issuance records for this item yet.</div>
      </div>
    </div>

    <!-- ============================ -->
    <!--      BULK ISSUE UPLOAD       -->
    <!-- ============================ -->
    <div *ngIf="isBulkIssueUploadMode" class="bulk-upload-container">
      <div class="template-download-link">
        <a *ngIf="!dialogData.isOrder" href="assets/templates/bulk-issue-upload-template-lt.xlsx" download="bulk-issue-upload-template.xlsx">
          Download Template
        </a>
        <a *ngIf="dialogData.isOrder" href="assets/templates/bulk_procured_items_template_am.xlsx" download="bulk-procured-upload-template.xlsx">
          Download Template
        </a>
      </div>
      <app-file-upload
        label="Select File or Drop Here to Upload"
        [error]="bulkUploadFileError"
        fileTypeText="Excel (.xls, .xlsx) or CSV format only, up to 5 MB"
        [accept]="'.xls,.xlsx,.csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/csv'"
        [selectedFile]="bulkUploadFile"
        (fileSelected)="onBulkFileSelected($event)"
        (fileRemoved)="onBulkFileRemoved()">
      </app-file-upload>
    </div>

    <!-- ============================ -->
    <!--         ISSUE NEW ITEM       -->
    <!-- ============================ -->
    <form *ngIf="dialogData.mode === 'issue-new-item'" [formGroup]="addInventoryForm" (ngSubmit)="onSubmit()"
      class="form-section">

      <div class="edit-inventory-fields-container">
        <app-dropdown class="emerald-dropdown dropdown-cls" [options]="categoryOptions" [label]="'Category'"
          [required]="true" [displayKey]="'label'" [valueKey]="'value'"
          (dropdownChange)="handleCategoryChange($event)" formControlName="category"></app-dropdown>
        <app-dropdown class="emerald-dropdown dropdown-cls" [options]="productOptionsForCategory" [label]="'Product'"
          [required]="true" [displayKey]="'label'" [valueKey]="'value'"
          formControlName="itemName"></app-dropdown>
            <app-input-field label="Issued To" [required]="true" type="text"
          formControlName="issuedTo"></app-input-field>
        <app-input-field label="Quantity" [required]="true" type="number" [min]="1"
          formControlName="issuedQuantity"></app-input-field>
        <app-dropdown class="emerald-dropdown dropdown-cls" [options]="locationOptions" [label]="'Location'"
          [required]="true" [displayKey]="'label'" [valueKey]="'value'"
          formControlName="location"></app-dropdown>
      
        <mat-form-field appearance="outline" >
          <mat-label>Date of Issue</mat-label>
          <input matInput [matDatepicker]="issuePicker" formControlName="dateOfIssue" required>
          <mat-datepicker-toggle matSuffix [for]="issuePicker"></mat-datepicker-toggle>
          <mat-datepicker #issuePicker></mat-datepicker>
        </mat-form-field>
        <app-input-field label="Purpose" [required]="true" type="text"
          formControlName="purpose"></app-input-field>
      </div>
    </form>

    <!-- ============================ -->
    <!--        ADD NEW ORDER        -->
    <!-- ============================ -->
    <form *ngIf="dialogData.mode === 'add'" [formGroup]="addNewForm" >

      <div class="add-new-order-fields-container" >
        <app-dropdown class="emerald-dropdown dropdown-cls" [options]="categoryOptions" label="Category"
          [required]="true" [displayKey]="'label'" [valueKey]="'value'"
          (dropdownChange)="handleCategoryChange($event)" formControlName="category"></app-dropdown>
        <app-dropdown class="emerald-dropdown dropdown-cls" [options]="productOptionsForCategory" label="Product"
          [required]="true" [displayKey]="'label'" [valueKey]="'value'"
          formControlName="itemName"></app-dropdown>
        <app-input-field label="Procured Quantity" type="number" [required]="true"
          formControlName="procuredQuantity"></app-input-field>

        <app-input-field label="Supplier Name" [required]="true" type="text"
          formControlName="supplierName"></app-input-field>
        <app-dropdown class="emerald-dropdown dropdown-cls" [options]="locationOptions" [label]="'Location'"
          [required]="true" [displayKey]="'label'" [valueKey]="'value'" formControlName="location"></app-dropdown>
        <mat-form-field appearance="outline">
          <mat-label>Date of Procurement</mat-label>
          <input matInput [matDatepicker]="procurementPicker" formControlName="dateOfProcurement" required>
          <mat-datepicker-toggle matSuffix [for]="procurementPicker"></mat-datepicker-toggle>
          <mat-datepicker #procurementPicker></mat-datepicker>
        </mat-form-field>

        <app-file-upload label="Select File(s) or Drop Here to Upload" [error]="fileError"
          fileTypeText="Pdf format only, upto 3 MB" [accept]="'application/pdf'" [selectedFile]="uploadedInvoice"
          (fileSelected)="onInvoiceSelected($event)" (fileRemoved)="onInvoiceRemoved()">
        </app-file-upload>
      </div>
    </form>

  </div>

  <!-- FOOTER -->
  <div class="form-footer">
    <ng-container [ngSwitch]="dialogData.mode">
      <!-- View Mode -->
      <ng-container *ngSwitchCase="'view'">
        <app-button-group [label]="'Cancel'" [buttonType]="'Secondary'" [buttonUseCase]="'Cancel'"
        [cssClass]="'cancel-btn'"
          (onEmit)="closeForm()"></app-button-group>
      </ng-container>

      <!-- View Invoice Mode -->
      <ng-container *ngSwitchCase="'view-invoice'">
        <app-button-group [label]="'Cancel'" [buttonType]="'Secondary'" [buttonUseCase]="'Cancel'"
        [cssClass]="'cancel-btn'"
          (onEmit)="closeForm()"></app-button-group>
        <app-button-group [label]="'Download'" [icon]="'download'" [buttonType]="'Secondary'" [cssClass]="'bordered-bg'" [disabled]="!safeInvoiceUrl"
          (onEmit)="downloadInvoice()"></app-button-group>
      </ng-container>

      <!-- Add Invoice Mode -->
      <ng-container *ngSwitchCase="'add-invoice'">
        <app-button-group [label]="'Cancel'" [buttonType]="'Secondary'" [buttonUseCase]="'Cancel'"
        [cssClass]="'cancel-btn'"
          (onEmit)="closeForm()"></app-button-group>
        <app-button-group [label]="'Save'" [buttonType]="'Primary'" [disabled]="invoiceForm.invalid"
          (onEmit)="submitInvoice()"></app-button-group>
      </ng-container>

      <!-- Issue New Item Mode -->
      <ng-container *ngSwitchCase="'issue-new-item'">
        <app-button-group [label]="'Cancel'" [cssClass]="'cancel-btn'" [buttonType]="'Secondary'" [buttonUseCase]="'Cancel'"
          (onEmit)="closeForm()"></app-button-group>
        <app-button-group [label]="'Save'" [buttonType]="'Primary'" [disabled]="addInventoryForm.invalid"
          (onEmit)="onSubmit()"></app-button-group>
      </ng-container>

      <!-- Bulk Issue Upload Mode -->
      <ng-container *ngSwitchCase="'bulk-issue-upload'">
        <app-button-group [label]="'Cancel'" [cssClass]="'cancel-btn'" [buttonType]="'Secondary'" [buttonUseCase]="'Cancel'"
          (onEmit)="closeForm()"></app-button-group>
        <app-button-group [label]="isBulkUploading ? 'Uploading...' : 'Upload'" [buttonType]="'Primary'" [disabled]="!bulkUploadFile || isBulkUploading"
          (onEmit)="onBulkUploadSubmit()"></app-button-group>
      </ng-container>

      <!-- Add New Order Mode -->
      <ng-container *ngSwitchCase="'add'">
        <app-button-group [label]="'Cancel'" [buttonType]="'Secondary'" [cssClass]="'cancel-btn'" [buttonUseCase]="'cancel'"
          (onEmit)="closeForm()"></app-button-group>
        <app-button-group [label]="'Save'" [buttonType]="'Primary'"
          [disabled]="addNewForm.invalid ||
    (addNewForm.controls['ordersAttachmentUrl'].touched &&
     !addNewForm.controls['ordersAttachmentUrl'].value)"
          (onEmit)="onSubmit()"></app-button-group>
      </ng-container>
    </ng-container>
  </div>
</div>